<template>
  <div>
    <h2 class="title is-4">User Preferences</h2>

    <div class="field">
      <label class="label">Language</label>
      <div class="control">
        <div class="select">
          <select v-model="form.language">
            <option value="en">English</option>
            <option value="fr">Français</option>
            <option value="nl">Nederlands</option>
          </select>
        </div>
      </div>
    </div>

    <div class="field">
      <label class="label">Theme</label>
      <div class="control">
        <div class="select">
          <select v-model="form.theme">
            <option value="light">Light</option>
            <option value="dark">Dark</option>
          </select>
        </div>
      </div>
    </div>

    <div class="field">
      <label class="label">Notifications</label>
      <div class="control">
        <label class="checkbox">
          <input type="checkbox" v-model="form.notifications" />
          Enable notifications
        </label>
      </div>
    </div>

    <div class="buttons">
      <button class="button" @click="$emit('prev')">Back</button>
      <button class="button is-primary" @click="next">Next</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepPreferences',
  props: {
    wizardData: { type: Object, required: true },
  },
  data() {
    return {
      form: {
        language: this.wizardData.preferences?.language || 'en',
        theme: this.wizardData.preferences?.theme || 'light',
        notifications: this.wizardData.preferences?.notifications ?? true,
      },
    };
  },
  methods: {
    next() {
      // ✅ Injecte les préférences dans wizardData.preferences
      this.$emit('next', { preferences: this.form });
    },
  },
};
</script>
